var map = {
	"./A0.png": 978,
	"./B0.png": 979,
	"./BB.png": 980,
	"./BD.png": 981,
	"./C0.png": 982,
	"./D0.png": 983,
	"./E0.png": 984,
	"./ecosentino-small.png": 985,
	"./ecosentino.png": 986,
	"./icon-dekton.png": 987,
	"./icon-scalea.png": 988,
	"./icon-sensa.png": 989,
	"./icon-silestone.png": 990,
	"./icon-table.png": 991,
	"./products/mktools.png": 992,
	"./sinks.png": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 768;